import "./stylesheets/App.css";
import Header from "./Components/Header/Header";
import Document from "./Components/Document/Document";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useHistory,
} from "react-router-dom";
import RoutePath from "./RoutePath";
import { NotFound } from "./NotFound";
import { AddReport } from "./Components/Document/AddReport";
import { EditReport } from "./Components/Document/EditReport";
import FaultDetails from "./Components/Document/FaultDetails";
import EditCustomerFault from "./Components/Document/EditCustomerFault";
import EditTrainFault from "./Components/Document/editTrainFault";
import ProtectedRoute from "./ProtectedRoute";
import LoginPage from "./LoginPage";
import { useSelector } from "react-redux";
import AuthPage from "./AuthPage";
import { FaultForm } from "./Components/Forms/FaultForm";
import ManageUsers from "./Components/ManageUser/ManageUsers";
import { ToastComponent } from "./Components/Utils/Toast";
import { UnSubscribe } from "./Components/Forms/UnSubscribe";

const App = () => {
  const loggedIn = useSelector((state) => !!state.tokenReducer.accessToken);
  const isTokenExpired = useSelector((state) => state.tokenReducer.isTokenExpired);

  return (
    <div className="App">
      <Router history={useHistory()}>
        {loggedIn && <Header loggedIn={loggedIn} />}

        <div
          className={loggedIn ? "documentSection" : "documentSection public"}
        >
          {isTokenExpired &&
            <div
              className="modal d-block modal-background"
              tabIndex="-1"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                <div className="modal-header token-alert">
              <h5 className="modal-title">
                Alert !
              </h5>
            </div>
                  <div className="modal-body text-center p-b-30 token-msg">
                    <p>Application idle time is exceeded, generating a new token...</p>
                  </div>
                </div>
              </div>
            </div>
          }
          <ToastComponent />
          <Switch>
            <ProtectedRoute
              component={LoginPage}
              open={!loggedIn}
              path="/login"
              redirect={RoutePath.home}
            />
            <ProtectedRoute
              exact
              path={RoutePath.documents}
              component={Document}
              open={loggedIn}
              redirect="/login"
            />
            <ProtectedRoute
              exact
              path={RoutePath.faultDetails}
              component={FaultDetails}
              open={loggedIn}
              redirect="/login"
            />
            <ProtectedRoute
              exact
              path={RoutePath.addReport}
              component={AddReport}
              open={loggedIn}
              redirect="/login"
            />
            <ProtectedRoute
              exact
              path={RoutePath.editReport}
              component={EditReport}
              open={loggedIn}
              redirect="/login"
            />
            <ProtectedRoute
              exact
              path={RoutePath.faultDetails}
              component={FaultDetails}
              open={loggedIn}
              redirect="/login"
            />
            <ProtectedRoute
              exact
              path={RoutePath.editCustomerFault}
              component={EditCustomerFault}
              open={loggedIn}
              redirect="/login"
            />
            <ProtectedRoute
              exact
              path={RoutePath.editTrainFault}
              component={EditTrainFault}
              open={loggedIn}
              redirect="/login"
            />
            <ProtectedRoute
              exact
              path={RoutePath.manageUser}
              component={ManageUsers}
              open={loggedIn}
              redirect="/login"
            />
            <Route exact component={FaultForm} path={RoutePath.faultForms} />
            <Route exact component={UnSubscribe} path={RoutePath.unSubscribeFault} />

            <Route exact component={AuthPage} path="/auth" />
            <Route exact path="/">
              <Redirect to="/login" />
            </Route>
            <Route
              path="/logout"
              component={() => {
                window.location = `${process.env.REACT_APP_AUTHORITY}/logout`;
                return null;
              }}
            />
            <Route component={NotFound} />
          </Switch>
        </div>
      </Router>
    </div>
  );
};

export default App;
